export default "__VITE_ASSET__CblfR4dF__"